import { type ChangeEvent, useEffect } from "react";
import get from "lodash/get";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { TextAreaWithCounter } from "@/react/pages/BotBuilder/BehaviorPage/TextAreaWithCounter";
import { Form } from "@circle-react-uikit/Form";
import { useCurrentAction } from "../../../ActionRule";
import { useDefaultValueForField } from "../../../useDefaultValueforField";

export const FormReportPost = () => {
  const { paramsPath, isSaved } = useCurrentAction();

  const { setValue, getValues, formState } = useFormContext();

  useDefaultValueForField(`${paramsPath}.reported_reason_body`, "");
  // Turn ON by default only for truly new actions
  useEffect(() => {
    if (!isSaved) {
      const current = getValues(`${paramsPath}.hide_until_approved`);
      const wasTouched = !!get(
        formState.touchedFields,
        `${paramsPath}.hide_until_approved`,
      );
      const isDirty = !!get(
        formState.dirtyFields,
        `${paramsPath}.hide_until_approved`,
      );
      if (
        (current === undefined || current === null || current === false) &&
        !wasTouched &&
        !isDirty
      ) {
        setValue(`${paramsPath}.hide_until_approved`, true, {
          shouldDirty: false,
          shouldTouch: false,
          shouldValidate: false,
        });
      }
    }
  }, [
    isSaved,
    getValues,
    setValue,
    paramsPath,
    formState.dirtyFields,
    formState.touchedFields,
  ]);

  const reportedReasonBody = getValues(
    `${paramsPath}.reported_reason_body`,
  ) as string;

  return (
    <div className="flex flex-col gap-[21px]">
      <Form.Item
        name={`${paramsPath}.hide_until_approved`}
        hideBorder
        fullWidth
        hideDescription
        hideLabel
        className="!py-0"
        rules={{ required: false }}
      >
        <div className="flex items-center">
          <span className="mr-4">
            <Form.ToggleSwitch
              variant="small"
              name={`${paramsPath}.hide_until_approved`}
            />
          </span>
          <Typography.LabelSm weight="semibold">
            {t(
              "settings.workflows.form.flag_post_for_review_and_hide_until_approved",
            )}
          </Typography.LabelSm>
        </div>
      </Form.Item>

      <Form.Item
        name={`${paramsPath}.reported_reason_body`}
        hideBorder
        fullWidth
        hideDescription
        label={t("settings.workflows.form.explanation")}
        labelClassName="!mb-2 !text-sm"
        className="!py-0"
        rules={{
          required: false,
        }}
        placeholder={t(
          "settings.workflows.form.ai_agents_report_post_placeholder",
        )}
      >
        <TextAreaWithCounter
          value={reportedReasonBody}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setValue(`${paramsPath}.reported_reason_body`, e.target.value)
          }
          name={`${paramsPath}.reported_reason_body`}
          rows={8}
          maxLength={500}
        />
      </Form.Item>
    </div>
  );
};
